export const mailTo = (mail?: string) => {
  return mail ? `mailto:${mail}` : "#";
};

export const tel = (tel?: string) => {
  return tel ? `tel:${tel}` : "#";
};
